export default {
      id: "ui-arrow-usage",
      viewBox: "0 0 159 46",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#ui-arrow",
      toString: function () {
        return this.url;
      }
    }